import { render, staticRenderFns } from "./Dash1.vue?vue&type=template&id=a144fbd0"
import script from "./Dash1.vue?vue&type=script&lang=js"
export * from "./Dash1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports